import baseAPI from '@/http'

const router = "api/login/login"

export const authAPI = {
    login: (login) => baseAPI.post(`${router}`, login),

}